export default __webpack_public_path__ + "static/media/topical_sample.d24b3674.jpg";